module.exports = "/assets/data/a795f27190ae92f3642cb77bdd51d274-HU8.data.json";